module.exports = __webpack_public_path__ + "static/media/mantap.00d760a0.png";